// To add new filter of columns by table, need to add a unique value on tableNames
// Pass the name of fields to new object like the example "closingOverviewMonth" and mapped into the component to use
// Add property "tableName" to the componente where using Table component. Example: tableNames={tableNames.closingsMyConciergeOverviewBuyers}
// In "adminSettingsSlice.js" add the value to "initialState" and the function to update it
// In the component of "Table.tsx" add the case following other cases
// In "DivisionSettings.tsx" add cases to "getList" and "updateReduxAdminSettings"

export const tableNames: any = {
  closingsOverviewMonth: "closingsOverviewMonth",
  closingsOverviewCommunity: "closingsOverviewCommunity",
  closingsOverviewQuarter: "closingsOverviewQuarter",
  closingsMyConciergeOverviewBuyers: "closingsMyConciergeOverviewBuyers",
};

/* ---------------- CLOSINGS OVERVIEW TAB ---------------- */

export const overviewProjected = {
  projected: { field: "projected", title: "Projected", canHide: true },
};
export const overviewScheduled = {
  scheduled: { field: "scheduled", title: "Scheduled", canHide: true },
};

export const overviewSold = {
  sold: { field: "sold", title: "Sold", canHide: true },
};
export const overviewClosed = {
  closed: { field: "closed", title: "Closed", canHide: true },
};
export const overviewExceptions = {
  exceptions: { field: "exceptions", title: "Exceptions", canHide: true },
};
export const overviewYear = {
  year: { field: "year", title: "Year", canHide: true },
};
export const overviewAlerts = {
  alerts: { field: "alerts", title: "Alerts", canHide: true },
};

export const closingsOverviewMonth = {
  month: { field: "month", title: "Month", canHide: false },
  ...overviewProjected,
  ...overviewScheduled,
  ...overviewSold,
  ...overviewClosed,
  ...overviewExceptions,
  ...overviewYear,
  ...overviewAlerts,
};

export const closingsOverviewCommunity = {
  communityId: { field: "communityId", title: "Community #", canHide: false },
  communityName: {
    field: "communityName",
    title: "Community Name",
    canHide: true,
  },
  ...overviewProjected,
  ...overviewScheduled,
  ...overviewSold,
  ...overviewClosed,
  ...overviewExceptions,
  closingConcierge: {
    field: "closingConcierge",
    title: "Closing Concierge",
    canHide: false,
  },
};

export const closingsOverviewQuarter = {
  quarter: { field: "quarter", title: "Quarter", canHide: false },
  ...overviewYear,
  ...overviewProjected,
  ...overviewScheduled,
  ...overviewSold,
  ...overviewClosed,
  ...overviewExceptions,
  ...overviewAlerts,
};

/* -------------- END CLOSINGS OVERVIEW TAB -------------- */

/* ---------------- MY CONCIERGE TAB - BUYERS ---------------- */

export const closingsMyConciergeOverviewBuyers = {
  buyerName: { field: "buyerName", title: "Buyer Name", canHide: false },
  homesite: {
    field: "homeSiteId",
    title: "Homesite #",
    canHide: false,
  },
  communityName: {
    field: "communityName",
    title: "Community Name",
    canHide: true,
  },
  buyerAddress: {
    field: "buyerAddress",
    title: "Buyer Address",
    canHide: true,
  },
  nhcName: {
    field: "nhcName",
    title: "NHC Name",
    canHide: true,
  },
  ecoeDate: {
    field: "ecoeDate",
    title: "ECOE Date",
    canHide: true,
  },
  opportunityId: {
    field: "opportunityId",
    title: "Opportunity ID",
    canHide: true,
  },
  saleDate: {
    field: "saleDate",
    title: "Sale Date",
    canHide: true,
  },
  hsAddress: {
    field: "hsAddress",
    title: "HS Address",
    canHide: true,
  },
  buyersEmail: {
    field: "buyersEmail",
    title: "Buyers Email",
    canHide: true,
  },
  buyersPhoneNumber: {
    field: "buyersPhoneNumber",
    title: "Buyers Phone Number",
    canHide: true,
  },
  taskCompletion: {
    field: "taskCompletion",
    title: "Task Completion",
    canHide: false,
  },
  totalExceptions: {
    field: "totalExceptions",
    title: "Total Exceptions",
    canHide: false,
  },
  totalAlerts: {
    field: "totalAlerts",
    title: "Total Alerts",
    canHide: false,
  },
  // Notes
  lender: {
    field: "lender",
    title: "Lender",
    canHide: true,
  },
  contingencyType: {
    field: "contingencyType",
    title: "Contingency Type",
    canHide: true,
  },
  loanType: {
    field: "loanType",
    title: "Loan Type",
    canHide: true,
  },
  broker: {
    field: "broker",
    title: "Broker",
    canHide: true,
  },
  constructionPhase: {
    field: "constructionPhase",
    title: "Current Construction Phase",
    canHide: true,
  },
};

/* -------------- ENDMY CONCIERGE TAB - BUYERS -------------- */
